import api from "@/services/api";
import type { VehiclesLookupResponse } from "../types";

export const getVehiclesLookup = async () => {
	const { data } = await api.get<VehiclesLookupResponse[]>(
		"/api/vehicle/lookup"
	);

	return data;
};
